<template>
  <div class="result-container">
    <BattleHeader title="墨客争霸" @back="goBack" />

    <!-- 主要内容区 -->
    <main class="result-main">
      <!-- 完成挑战提示 -->
      <div class="result-stats">
        <h2 class="result-subtitle">
          书法大神
        </h2>
        <p class="result-description">
          恭喜您完成本次挑战！
        </p>
        <div class="stats-grid">
          <div class="stat-item">
            <div class="stat-icon correct">
              <i class="fas fa-check"></i>
            </div>
            <p class="stat-number correct">
              {{ correctAnswers }}
            </p>
            <p class="stat-label">
              正确
            </p>
          </div>
          <div class="stat-item">
            <div class="stat-icon wrong">
              <i class="fas fa-times"></i>
            </div>
            <p class="stat-number wrong">
              {{ wrongAnswers }}
            </p>
            <p class="stat-label">
              错误
            </p>
          </div>
          <div class="stat-item">
            <div class="stat-icon time">
              <i class="fas fa-clock"></i>
            </div>
            <p class="stat-number time">
              {{ timeSpentMinutes }}
            </p>
            <p class="stat-label">
              耗时(分)
            </p>
          </div>
        </div>
        <div class="ranking-section">
          <p class="challenge-info">
            在{{ timeLimit }}分钟挑战赛中排名
          </p>
          <p class="ranking-display">
            第<span class="ranking-number">{{ ranking }}</span>名
          </p>
        </div>
      </div>

      <!-- 底部操作按钮 -->
      <div class="action-buttons">
        <button 
          @click="retryChallenge" 
          class="retry-btn"
        >
          <i class="fas fa-redo-alt">
          </i>
          重新挑战
        </button>
        <button 
          @click="shareScore" 
          class="share-btn"
        >
          <i class="fas fa-share-alt">
          </i>
          分享好友
        </button>
        <div class="back-to-home">
          <router-link to="/" class="home-link">
            <i class="fas fa-home"></i> 回到主页
          </router-link>
        </div>
      </div>
    </main>
  </div>
</template>

<script>
import { updateQuizNickname, getWxConfig } from '@/api/api'
import { alert, confirm } from '@/utils/modal'
import wx from "weixin-js-sdk";
import BattleHeader from '@/components/BattleHeader.vue'

export default {
  components: { BattleHeader },
  name: 'ResultPage',
  data() {
    return {
      nickname: '',
      score: 0,
      correctAnswers: 0,
      wrongAnswers: 0,
      timeLimit: 30,
      ranking: 1,
      recordId: null
    }
  },
  computed: {
    timeSpentMinutes() {
      return this.timeLimit;
    }
  },
  mounted() {
    // 从路由参数获取数据
    this.score = parseInt(this.$route.query.score) || 0;
    this.correctAnswers = parseInt(this.$route.query.correct) || 0;
    this.wrongAnswers = parseInt(this.$route.query.wrong) || 0;
    this.timeLimit = parseInt(this.$route.query.timeLimit) || 30;
    this.ranking = parseInt(this.$route.query.ranking) || 1;
    this.recordId = this.$route.query.recordId || null;
    
    // 计算错误答案数量
    if (this.wrongAnswers === 0 && this.correctAnswers > 0) {
      this.wrongAnswers = 12 - this.correctAnswers; // 假设总题数为12
    }
    // 首先获取微信配置
    this.getWxConfig();   
  },
  methods: {
    // 获取微信配置
    getWxConfig() {
      getWxConfig({ url: encodeURIComponent(location.href.split('#')[0]) }).then(res => {
        if (res && res.code === 1) {
          const data = res.data;
          // 配置微信 JS-SDK
          wx.config({
            debug: false,
            appId: data.appId,
            timestamp: data.timestamp,
            nonceStr: data.nonceStr,
            signature: data.signature,
            jsApiList: ['updateAppMessageShareData', 'updateTimelineShareData']
          });
          
          // 配置成功后设置 ready 回调
          wx.ready(() => {
            const shareTitle = '墨客争霸答题成绩';
            // 配置微信分享参数
            const shareConfig = {
              title: shareTitle,
              desc: `我在墨客争霸答题竞赛中答对了${this.correctAnswers}题，快来挑战我吧！`,
              link: window.location.origin,
              imgUrl: `${window.location.origin}/favicon.ico`, // 使用网站图标作为分享图片
              success: function() {
                console.log('微信分享成功');
              }
            };
            
            // 更新朋友圈分享内容
            if (wx.updateTimelineShareData) {
              wx.updateTimelineShareData(shareConfig);
            } else {
              // 兼容旧版微信JS-SDK
              wx.onMenuShareTimeline(shareConfig);
            }
            
            // 更新好友分享内容
            if (wx.updateAppMessageShareData) {
              wx.updateAppMessageShareData(shareConfig);
            } else {
              // 兼容旧版微信JS-SDK
              wx.onMenuShareAppMessage(shareConfig);
            }
          });
          
          // 配置失败回调
          wx.error((err) => {
            console.error('微信 JS-SDK 初始化失败:', err);
          });
        }
      }).catch(error => {
        console.error('获取微信配置失败:', error);
      });
    },
    goBack() {
      this.$router.push('/');
    },
    goToRanking() {
      this.$router.push('/ranking');
    },
    startNewChallenge() {
      this.$router.push('/');
    },
    async saveNickname() {
      if (!this.nickname.trim()) {
        await alert('请输入昵称');
        return;
      }
      
      if (this.nickname.length > 8) {
        await alert('昵称不能超过8个字符');
        return;
      }
      if (!this.recordId) {
        await alert('未找到答题记录，无法保存昵称');
        return;
      }

      updateQuizNickname({ id: this.recordId, nickname: this.nickname }).then(async res => {
        if (res && res.code === 1) {
          await alert(`保存成功！`);
          this.$router.push('/');
        } else {
          await alert('保存失败');
        }
      })
    },
    async retryChallenge() {
      if (await confirm('确定要重新挑战吗？')) {
        this.$router.push('/quiz');
      }
    },
    // 检测是否在微信环境中
    isWeChat() {
      const ua = navigator.userAgent.toLowerCase();
      return /micromessenger/.test(ua);
    },
    
    async shareScore() {
      const shareText = `我在墨客争霸答题竞赛中答对了${this.correctAnswers}题，快来挑战我吧！\n\n${window.location.origin}`;
      const shareTitle = '墨客争霸答题成绩';
      
      // 检查是否在微信环境中
      if (this.isWeChat()) {
        await alert('请点击右上角分享给好友或朋友圈');
        return;
      } else {
        // 尝试使用浏览器的Web Share API
        if (navigator.share) {
          try {
            await navigator.share({
              title: shareTitle,
              text: `我在墨客争霸答题竞赛中答对了${this.correctAnswers}题，快来挑战我吧！`,
              url: window.location.origin
            });
            console.log('分享成功');
            return;
          } catch (error) {
            console.error('分享失败:', error);
            // 如果 Web Share API 失败，降级到剪贴板复制
          }
        }

        // 优先尝试使用现代的 Clipboard API (iOS 14+ 支持)
        if (navigator.clipboard && navigator.clipboard.writeText) {
          try {
            await navigator.clipboard.writeText(shareText);
            await alert('分享内容已复制到剪贴板，您可以手动分享给好友');
            return;
          } catch (err) {
            console.error('Clipboard API 失败:', err);
            // 降级到备用方案
          }
        }
        
        // 如果浏览器不支持上述API，使用传统的document.execCommand方法
        await this.fallbackShare(shareText);
        
      }
      
    },
    async fallbackShare(shareText) {
      // 创建一个临时的文本区域用于复制
      const tempTextArea = document.createElement('textarea');
      tempTextArea.value = shareText;
      tempTextArea.style.position = 'fixed';
      tempTextArea.style.left = '-999999px';
      tempTextArea.style.top = '-999999px';
      document.body.appendChild(tempTextArea);
      
      try {
        // 选择文本并复制
        tempTextArea.focus();
        tempTextArea.select();
        tempTextArea.setSelectionRange(0, 999999); // 支持移动设备
        
        // 尝试使用document.execCommand('copy')
        const successful = document.execCommand('copy');
        
        if (successful) {
          await alert('分享内容已复制到剪贴板，您可以手动分享给好友');
        } else {
          await alert('复制失败，请手动选择并复制页面内容');
        }
      } catch (err) {
        console.error('复制失败:', err);
        await alert('您的浏览器不支持自动复制功能，请手动选择并复制页面内容');
      } finally {
        // 清理临时元素
        document.body.removeChild(tempTextArea);
      }
    }
  }
}
</script>

<style scoped>
.result-container {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  background-color: #F5F5F5;
  font-family: 'PingFang SC', 'Helvetica Neue', Arial, sans-serif;
}

.result-main {
  flex: 1;
  padding: calc(var(--battle-header-height) + 20px) 24px 24px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.result-stats {
  background-color: white;
  border-radius: 16px;
  padding: 32px 24px;
  margin-bottom: 32px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
}

.result-subtitle {
  font-size: clamp(2rem, 5vw, 3rem);
  font-weight: bold;
  color: #D54D24;
  margin-top: -10px;
  margin-bottom: 8px;
  text-align: center;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.result-description {
  font-size: 16px;
  color: #999999;
  margin-bottom: 32px;
  text-align: center;
}

.stats-grid {
  display: flex;
  justify-content: space-around;
  gap: 20px;
  margin-bottom: 32px;
}

.stat-item {
  text-align: center;
  flex: 1;
}

.stat-icon {
  width: 60px;
  height: 60px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 12px;
  font-size: 24px;
}

.stat-icon.correct {
  background-color: rgba(16, 185, 129, 0.1);
  color: #10B981;
}

.stat-icon.wrong {
  background-color: rgba(239, 68, 68, 0.1);
  color: #EF4444;
}

.stat-icon.time {
  background-color: rgba(59, 130, 246, 0.1);
  color: #3B82F6;
}

.stat-number {
  font-size: 24px;
  font-weight: bold;
  margin-bottom: 4px;
}

.stat-number.correct {
  color: #10B981;
}

.stat-number.wrong {
  color: #EF4444;
}

.stat-number.time {
  color: #3B82F6;
}

.stat-label {
  color: #999999;
  font-size: 12px;
  margin: 0;
}

.ranking-section {
  background-color: #F8F8F8;
  border-radius: 12px;
  padding: 24px;
  text-align: center;
}

.challenge-info {
  color: #999999;
  font-size: 14px;
  margin-bottom: 16px;
  text-align: center;
}

.ranking-display {
  font-size: 28px;
  font-weight: bold;
  color: #333333;
  margin: 0;
}

.ranking-number {
  color: #D54D24;
  font-size: 48px;
}

.action-buttons {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.retry-btn {
  width: 100%;
  padding: 16px;
  background-color: white;
  border: 2px solid #D54D24;
  color: #D54D24;
  border-radius: 12px;
  font-size: 16px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
}

.retry-btn:hover {
  background-color: #FFF5F0;
}

.share-btn {
  width: 100%;
  padding: 16px;
  background-color: #D54D24;
  color: white;
  border: none;
  border-radius: 12px;
  font-size: 16px;
  font-weight: 500;
  cursor: pointer;
  transition: background-color 0.3s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
}

.share-btn:hover {
  background-color: #C2410C;
}

.back-to-home {
  text-align: center;
  margin-top: 24px;
}

.home-link {
  color: #3B82F6;
  text-decoration: none;
  font-size: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
}

.home-link:hover {
  text-decoration: underline;
}
</style>
